import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { AzureOauthResponseComponent } from './modules/azure-oauth-response/azure-oauth-response.component';
import { DashboardComponent } from './modules/dashboard/dashboard.component';
import { LoginComponent } from './modules/login/login.component';
import { ManageAzureAccountsComponent } from './modules/manage-azure-accounts/manage-azure-accounts.component';
import { ManageEndpointsComponent } from './modules/manage-endpoints/manage-endpoints.component';
import { ManageNamespacesComponent } from './modules/manage-namespaces/manage-namespaces.component';


const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard] },
  { path: 'azureaccounts', component: ManageAzureAccountsComponent, canActivate: [AuthGuard] },
  { path: 'namespaces', component: ManageNamespacesComponent, canActivate: [AuthGuard] },
  { path: 'endpoints', component: ManageEndpointsComponent, canActivate: [AuthGuard] },
  { path: 'azureoauthresponse', component: AzureOauthResponseComponent, canActivate: [AuthGuard] }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
